import selectAfterMoveActionOption from '../actions/selectAfterMoveActionOption';
import selectLoadMessageOnSignOnOption from '../actions/selectLoadMessageOnSignOnOption';
import selectReadingPanePositionOption from '../actions/selectReadingPanePositionOption';
import ReadingPaneOptionState from '../store/schema/ReadingPaneOptionState';
import store from '../store/store';
import { ChoiceGroupWithImages } from 'owa-choice-group-with-images';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getFallbackValueIfNull } from 'owa-options-core';
import NextSelectionDirection from 'owa-service/lib/contract/NextSelectionDirection';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

const READING_PANE_RIGHT_SVG = require('./readingPaneRightLarge.svg');
const READING_PANE_OFF_SVG = require('./readingPaneOffLarge.svg');
const READING_PANE_BOTTOM_SVG = require('./readingPaneBottomLarge.svg');

export interface ReadingPaneFullProps {
    userOptions?: UserOptionsType;
    optionState?: ReadingPaneOptionState;
}

@reactive({
    userOptions: () => getUserConfiguration().UserOptions,
    optionState: () => store,
})
export default class ReadingPaneFull extends React.Component<ReadingPaneFullProps, {}> {
    render() {
        let { userOptions, optionState } = this.props;

        let readingPanePositionSelectedKey = `${getFallbackValueIfNull(
            optionState.readingPanePosition,
            userOptions.GlobalReadingPanePositionReact
        )}`;
        let actionAfterMoveKey = optionState.nextSelection || userOptions.NextSelection;
        let showReadingPaneOnFirstLoadSelectedKey = `${getFallbackValueIfNull(
            optionState.loadMessageOnLogOn,
            userOptions.ShowReadingPaneOnFirstLoad
        )}`;

        // Account for the case where RP is not 'Off', but we should 'ReturnToView' after move/delete
        // This is done in the view to preserve the underlying selection if a users switches RP position back and forth
        if (
            readingPanePositionSelectedKey !== `${ReadingPanePosition.Off}` &&
            actionAfterMoveKey === 'ReturnToView'
        ) {
            actionAfterMoveKey = 'Next';
        }

        let options = [
            {
                key: `${ReadingPanePosition.Right}`,
                text: strings.options_readingPane_positionRight,
                imageUri: READING_PANE_RIGHT_SVG,
                width: 280,
            },
            {
                key: `${ReadingPanePosition.Bottom}`,
                text: strings.options_readingPane_positionBottom,
                imageUri: READING_PANE_BOTTOM_SVG,
                width: 280,
            },
            {
                key: `${ReadingPanePosition.Off}`,
                text: strings.options_readingPane_positionHide,
                imageUri: READING_PANE_OFF_SVG,
                width: 280,
            },
        ];
        return (
            <div>
                <ChoiceGroupWithImages
                    selectedKey={readingPanePositionSelectedKey}
                    label={strings.options_readingPane_positionLabel}
                    options={options}
                    onChange={this.onChangeReadingPane}
                />
                <ChoiceGroup
                    selectedKey={actionAfterMoveKey}
                    label={strings.options_readingPane_afterMove_title}
                    options={[
                        {
                            key: 'Next',
                            text: strings.options_readingPane_afterMove_next,
                        },
                        {
                            key: 'Previous',
                            text: strings.options_readingPane_afterMove_previous,
                        },
                        {
                            key: 'ReturnToView',
                            text: strings.options_readingPane_afterMove_returnToView,
                            disabled:
                                readingPanePositionSelectedKey !== `${ReadingPanePosition.Off}`,
                        },
                    ]}
                    onChange={this.onAfterMoveActionChange}
                />
                <ChoiceGroup
                    selectedKey={showReadingPaneOnFirstLoadSelectedKey}
                    label={strings.options_readingPane_actionOnLoadLabel}
                    options={[
                        {
                            key: 'true',
                            text: strings.options_readingPane_actionOnLoadFirstItem,
                        },
                        {
                            key: 'false',
                            text: strings.options_readingPane_actionOnLoadNoAction,
                        },
                    ]}
                    onChange={this.onChangeLoadMessage}
                />
            </div>
        );
    }

    private onAfterMoveActionChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectAfterMoveActionOption(option.key as NextSelectionDirection);
    };

    private onChangeReadingPane = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectReadingPanePositionOption(parseInt(option.key, 10));
    };

    private onChangeLoadMessage = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectLoadMessageOnSignOnOption(option.key === 'true');
    };
}
